<template>
  <v-col class="no-bottom-pad">
    <v-card flat tile v-if="color">
      <v-img
        lazy-src="https://placehold.co/100x100"
        class="rounded"
        :height="height"
        :max-width="width"
        :src="tile"
        :alt="color.color"
      />
      <v-card-text v-if="withName" class="text-left">
        {{color.color}}
      </v-card-text>
    </v-card>
  </v-col>
</template>

<style scoped lang="scss">
  .v-card__text {
    padding: 10px 20px 0 0 !important;
    font-size: 13px;
  }
  .no-bottom-pad {
    padding-bottom: 0 !important;
  }
</style>

<script>
import { getTile } from '@/services/assets'

export default {
  props: {
    color: Object,
    small: Boolean,
    withName: Boolean,
  },
  computed: {
    tile: function() {
      return getTile(this.color)
    },
    width: function() {
      return this.small ? '100%' : 200
    },
    height: function() {
      return this.small ? 75 : 100
    }
  }
}
</script>